"use strict"

window.app = window.app || {}

window.app = ((app) => {

    NodeList.prototype.forEach = Array.prototype.forEach

    app.initCallbacks = []
    app.addInitCallback = function(fn) {
        app.initCallbacks.push(fn)
    }

    app.init = () => {
        app.initCallbacks.forEach(cb => cb(app))

        // MENU BURGER
        const $burger = document.querySelector(".navbar .menu-burger")
        $burger.addEventListener("click", e => {
            e.preventDefault()
            const $navbar = document.querySelector(".navbar nav")
            $navbar.classList.contains("show")
                ? $navbar.classList.remove("show")
                : $navbar.classList.add("show")
        })

        // submenu
        const $submenus = $('.navbar ul.l1 > li.with-submenu');
        $('.navbar ul.l1 > li.with-submenu > a').on('click', function(ev){
            let $el = $(this).closest('li');
            if ($el.hasClass('open')) {
                $el.removeClass('open');
            } else {
                $submenus.removeClass('open');
                $el.addClass('open');
            }
            ev.preventDefault();
            return false;
        });

        // INFOBOXES
        const $infoboxes = document.querySelectorAll(".infoboxes .infoboxes__row")
        const
            mqMobile = window.matchMedia("(max-width: 720px)")
        if($infoboxes.length > 0 && mqMobile.matches) {
            const settings = {
                itemNumber: 0,
                showItem: true,
                elementClass: "infoboxes__infobox",
                questionClass: "infobox__heading",
                answerClass: "infobox__content",
            }
            if(document.getElementById("accordion-1"))
                new Accordion("#accordion-1", settings)
            if(document.getElementById("accordion-2"))
                new Accordion("#accordion-2", settings)
            if(document.getElementById("accordion-3"))
                new Accordion("#accordion-3", settings)
        }
        $('.infobox__toggler').on('click', function(ev){
            let $el = $(this).next('.infobox__content');
            $el.toggleClass('infobox__content_hidden');
        });

        // NEWSLINE
        $('.newsline').slick({
            //variableWidth: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 2000,
            speed: 2000,
        })

        $('.marquee').marquee({
            speed: 300,
            gap: 50,
            delayBeforeStart: 0,
            direction: 'left',
            duplicated: true,
            pauseOnHover: true
        });

        // SLIDESHOW
        $('.slideshow .slideshow__cont').slick({
            prevArrow: ".slideshow .slideshow__arr--left",
            nextArrow: ".slideshow .slideshow__arr--right",
            adaptiveHeight: true,
        })

        // CATEGORY POPUP
        document.querySelectorAll(".infobox__table--popup-active")
            .forEach($infobox => {
                $infobox.querySelectorAll("tr")
                    .forEach($row => {
                        $row.addEventListener("click", e => {
                            popupOpen($row.attributes["data-id"].value)
                        })
                    })
            })

        // Obecný POPUP
        document.querySelectorAll(".popup-trigger")
            .forEach($item => {
                $item.addEventListener("click", e => {
                    popupOpen($item.attributes["data-id"].value)
                })
            })


    }

    const popupOpen = id => {
        Swal.fire({
            html: document.getElementById(id).innerHTML,
            width: 1100,
            showConfirmButton: false,
            onOpen: () => {
                document.querySelector(".swal2-container .category-popup__close").addEventListener("click", e => {
                    e.preventDefault()
                    Swal.close()
                })
            }
        })
    }

    app.tag = (name, attrs = {}) => {
        let el = document.createElement(name.toString())
        !!attrs && Object.keys(attrs).forEach(key => el.setAttribute(key, attrs[key]))
        return el
    }

    return app
})(window.app)